import React from 'react';

class ErrorBoundary extends React.Component {
  static getDerivedStateFromError(error) {
    //  reload the page if the error matches
    if (error.message.includes('Failed to fetch dynamically imported module')) {
      window.location.reload();
    }
    return null;
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
